/**
 * Tagada Rx — overview page.
 *
 * The guided onboarding journey (apply → review → get paid → launch)
 * always leads the page; it collapses into a slim confirmation bar once
 * setup is complete. Pre-activation the page also sells the model
 * ("How it works" + earnings simulator); post-activation the store
 * dashboard takes over.
 */

'use client';

import { useTranslation } from 'react-i18next';

import { useStoreNavigate } from '@/hooks/use-app-navigate';
import {
  RxDashboard,
  RxDocsCard,
  RxEarningsSimulator,
  RxOnboardingDiagram,
  RxOnboardingJourney,
  RxPageShell,
} from '@/components/rx';
import { useRxIntegrationStatus } from '@/lib/api/rx';

export default function RxOverviewPage() {
  const { t } = useTranslation('rx');
  const { id: storeId } = useStoreNavigate();
  const statusQuery = useRxIntegrationStatus(storeId);
  const active = statusQuery.data?.state === 'active';

  return (
    <RxPageShell
      title={t('overview.title')}
      description={t('overview.description')}
    >
      <RxDocsCard />
      <RxOnboardingJourney storeId={storeId} />
      {active ? (
        <RxDashboard storeId={storeId} />
      ) : (
        <>
          <RxOnboardingDiagram />
          <RxEarningsSimulator storeId={storeId} />
        </>
      )}
    </RxPageShell>
  );
}
